import { StyleSheet } from 'react-native';
import ThermenImage from 'src/presentation/components/molecules/ThermenImage';
import Dimens from 'src/core/utils/Dimens';
import radioSelected from 'assets/images/radioselected.png';
import radioUnselected from 'assets/images/radiounselected.png';

const styles = StyleSheet.create({
	radioImage: {
		height: Dimens.size25,
		width: Dimens.size25,
		justifyContent: 'center',
		alignItems: 'center',
		marginRight: Dimens.padding5,
	},
});

interface ButtonProps {
	selected?: boolean;
	disabled?: boolean;
}

export function RadioButton({ selected, disabled }: ButtonProps) {
	return selected ? (
		<ThermenImage source={radioSelected} style={styles.radioImage} />
	) : (
		<ThermenImage source={radioUnselected} style={styles.radioImage} />
	);
}
